import React, { useEffect, useMemo } from 'react';
import { Card, CardBody } from 'reactstrap';
import { useFormikContext } from 'formik';
import * as Yup from 'yup';

export const TotalesSectionSpec = {
	getInitialValues: () => ({
		totals_mnt_neto: 0,
		totals_mnt_exe: 0,
		totals_tasa_iva: 19,
		totals_iva: 0,
		totals_mnt_total: 0,
	}),
	getValidationSchema: () =>
		Yup.object({
			// Totales calculados; no requeridos explícitamente
		}),
	toPayload: values => ({
		dtefacele: {
			Encabezado: {
				Totales: {
					MntNeto: Number(values.totals_mnt_neto) || 0,
					MntExe: Number(values.totals_mnt_exe) || 0,
					TasaIVA: Number(values.totals_tasa_iva) || 0,
					IVA: Number(values.totals_iva) || 0,
					MntTotal: Number(values.totals_mnt_total) || 0,
				},
			},
		},
	}),
};

export const TotalesSection = () => {
	const validation = useFormikContext();

	const items = Array.isArray(validation.values.items)
		? validation.values.items
		: [];

	const tasaIva = Number(validation.values.totals_tasa_iva) || 0;
	const montoExento = Number(validation.values.totals_mnt_exe) || 0;

	const montoNeto = useMemo(() => {
		return items.reduce((acc, it) => {
			const monto = Number(it?.MontoItem) || 0;
			return acc + monto;
		}, 0);
	}, [items]);

	const montoIva = useMemo(() => {
		return Math.round(montoNeto * (tasaIva / 100));
	}, [montoNeto, tasaIva]);

	const montoTotal = useMemo(() => {
		return montoNeto + montoIva + montoExento;
	}, [montoNeto, montoIva, montoExento]);

	useEffect(() => {
		validation.setFieldValue('totals_mnt_neto', montoNeto, false);
		validation.setFieldValue('totals_iva', montoIva, false);
		validation.setFieldValue('totals_mnt_total', montoTotal, false);
	}, [montoNeto, montoIva, montoTotal]);

	const formatCurrency = value => {
		try {
			return (Number(value) || 0).toLocaleString('es-CL');
		} catch (e) {
			return `${value}`;
		}
	};

	return (
		<Card className='border mb-0'>
			<CardBody className='p-3'>
				<div className='d-flex justify-content-between py-1'>
					<span className='text-muted'>MONTO NETO</span>
					<span>{formatCurrency(montoNeto)}</span>
				</div>
				<div className='d-flex justify-content-between py-1'>
					<span className='text-muted'>MONTO IVA {tasaIva}%</span>
					<span>{formatCurrency(montoIva)}</span>
				</div>
				<div className='d-flex justify-content-between py-1'>
					<span className='text-muted'>MONTO EXENTO</span>
					<span>{formatCurrency(montoExento)}</span>
				</div>
				<hr className='my-2' />
				<div className='d-flex justify-content-between py-1'>
					<strong>MONTO TOTAL</strong>
					<strong>{formatCurrency(montoTotal)}</strong>
				</div>
			</CardBody>
		</Card>
	);
};
